import VALIDATIONS from '../../apiPublic/ressources/validations';

export const validatePhoneNumber = async(countryCode, number) => {
  const params = { full_phone: { phone_number: number, phone_country_code: countryCode } };

  const response = await VALIDATIONS.phoneNumber(params);
  return response.data;
};

export const validateEmail = (email) => {
  const EMAIL_REGEX = /^([A-Za-z0-9]+_+|[A-Za-z0-9]+-+|[A-Za-z0-9]+\.+|[A-Za-z0-9]+\++)*[A-Za-z0-9\-_]+@((\w+-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,6}$/i;

  return EMAIL_REGEX.test(email);
};
